<template lang="html">
  <div class="products-admin-wrapper">
    <div class="title">
      <span>Objave</span>
      <input
        @keyup="getProducts(), (page = 1)"
        v-model="search"
        type="text"
        placeholder="search"
        name=""
        value=""
      />
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>naziv</td>
            <td>količina</td>
            <td>cena</td>
            <td>vlasnik</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>promocija</td>
            <td>status</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products" :key="product.pro_id">
            <td class="underline" @click="navigateToAd(product.pro_id, $event)">
              {{ product.pro_name }}
            </td>
            <td>
              {{ product.quantity }}
            </td>
            <td>{{ product.current_price }} {{ product.cur_id }}</td>
            <td>
              {{ product.usr_name }}
            </td>
            <td>
              <div
                v-if="
                  product.admin_deleted !== 1 && product.pro_deleted === null
                "
                @click="openConfirmModal(product, 'delete')"
                class="btn"
              >
                {{ deleteLabel(product) }}
              </div>
            </td>
            <td>
              <div
                v-if="
                  product.admin_deleted !== 1 && product.pro_deleted === null
                "
                @click="openConfirmModal(product, 'block')"
                class="btn"
              >
                {{ blockLabel(product) }}
              </div>
            </td>
            <td>
              <div
                v-if="
                  product.admin_deleted !== 1 && product.pro_deleted === null
                "
                @click="openGroupModal(product)"
                class="btn"
              >
                Grupa
              </div>
            </td>
            <td>
              <div
                v-if="
                  product.admin_deleted !== 1 && product.pro_deleted === null
                "
                @click="openPromotionModal(product)"
                class="btn"
              >
                promeni promociju
              </div>
            </td>
            <td>
              {{
                product.prm_position ? product.prm_position : 'nema promociju'
              }}
            </td>
            <td>
              {{ getStatus(product) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="products.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
import { api } from '@/api'
export default {
  name: 'productsAdmin',
  data () {
    return {
      products: [],
      page: 1,
      pageCount: 0,
      search: null
    }
  },
  mounted () {
    this.getProducts()
  },
  methods: {
    navigateToAd (id, e) {
      e.stopPropagation()
      this.$router.push({
        name: 'Details',
        params: { lang: this.$i18n.locale, id: id }
      })
    },
    getProducts () {
      let params = {
        page: this.page
      }
      if (this.search && this.search !== '') {
        params.search = this.search
      }
      api
        .getAllProducts(params)
        .then(res => {
          this.products = res.data.data
          this.pageCount = res.data.page_count
        })
        .catch(e => {
          console.log(e)
        })
    },
    getStatus (product) {
      if (product.admin_deleted === 1) {
        return 'Admin obrisao ' + product.pro_deleted
      } else if (product.pro_deleted !== null) {
        return 'Obrisan ' + product.pro_deleted
      } else if (product.sold_out !== 0) {
        return 'Rasprodato'
      } else {
        return parseInt(product.expires_in) < 0
          ? 'isteklo pre ' + Math.abs(product.expires_in) + ' dana'
          : 'aktivno još ' + product.expires_in + ' dana'
      }
    },
    openConfirmModal (pro, type) {
      let modalData = {}
      if (type === 'delete') {
        modalData.title = 'Ukloni ovu objavu '
        modalData.ok = () => {
          this.deleteProduct(pro)
        }
      } else if (type === 'block') {
        modalData.title = 'Promeni blokadu ove objave '
        modalData.ok = () => {
          this.changeBlock(pro)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    openGroupModal (pro) {
      let modalData = {
        title: 'Dodaj objavu u grupu:',
        group: pro.grp_id,
        ok: group => {
          this.changeGroup(pro, group)
        }
      }
      let params = {
        modalData: modalData,
        component: 'changeGroupModal'
      }
      eventBus.$emit('openModal', params)
    },
    changeGroup (pro, group) {
      console.log(pro, group)
      let params = {
        pro_id: pro.pro_id
      }
      if (group !== 'delete') {
        params.grp_id = group
      }
      api
        .changeProductGroup(params)
        .then(res => {
          this.getProducts()
          this.$toast.success('Uspešno', {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error('Greška', {
            duration: 8000
          })
        })
    },
    openPromotionModal (pro) {
      let modalData = {
        title: 'Izaberi poziciju u kategoriji:',
        promotion: pro.prm_position,
        ok: promotion => {
          this.changePromotion(pro, promotion)
        }
      }
      let params = {
        modalData: modalData,
        component: 'changePromotionModal'
      }
      eventBus.$emit('openModal', params)
    },
    changePromotion (pro, promotion) {
      console.log(pro, promotion)
      let params = {
        pro_id: pro.pro_id,
        prm_position: promotion
      }
      api
        .changeProductPromotion(params)
        .then(res => {
          this.getProducts()
          this.$toast.success('Uspešno', {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error('Greška', {
            duration: 8000
          })
        })
    },
    deleteProduct (pro) {
      let params = {
        delete_pro: true,
        pro_id: pro.pro_id
      }
      eventBus.$emit('showLoader', true)
      api
        .changeProduct(params)
        .then(res => {
          this.getProducts()
          this.$toast.success('Uspešno', {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error('Greška', {
            duration: 8000
          })
        })
        .finally(() => {
          eventBus.$emit('showLoader', false)
        })
    },
    changeBlock (pro) {
      let params = {
        unlock: pro.pro_unlocked === 0,
        pro_id: pro.pro_id
      }
      api
        .changeProduct(params)
        .then(res => {
          this.getProducts()
          this.$toast.success('Uspešno', {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error('Greška', {
            duration: 8000
          })
        })
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.products = []
      this.getProducts()
    }
  },
  computed: {
    deleteLabel () {
      return pro => {
        return pro.pro_deleted === null ? 'Ukloni' : 'Vrati'
      }
    },
    blockLabel () {
      return pro => {
        return pro.pro_unlocked === 0 ? 'Otključaj' : 'Zaključaj'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.products-admin-wrapper {
  @import '@/assets/scss/tableStyles.scss';
  @import '@/assets/scss/btnStyles.scss';
  padding-left: 40px;
  box-sizing: border-box;
  height: 100%;
  position: relative;

  .btn {
    line-height: 13px;
    padding: 0 10px;
  }
  .products-admin-wrapper table tbody tr td {
    padding: 0 5px !important;
  }

  .table-wrapper {
    height: calc(100% - 160px);
    overflow: auto;
  }

  .title {
    margin-bottom: 40px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding-right: 20px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      max-width: 230px;
    }
    input:focus {
      outline: none;
    }
  }
  .switcher {
    display: flex;
    flex-direction: row;
    .btn {
      width: 150px;
    }
  }
}
</style>
<style media="screen">
.products-admin-wrapper .underline {
  text-decoration: underline !important;
  cursor: pointer;
}
.products-admin-wrapper table tbody tr td {
  padding: 5 8px !important;
}
</style>
